import { render, staticRenderFns } from "./confirm.vue?vue&type=template&id=aa591452&scoped=true"
import script from "./confirm.vue?vue&type=script&lang=js"
export * from "./confirm.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/style-review.css?vue&type=style&index=0&id=aa591452&prod&scoped=true&lang=css&external"
import style1 from "./confirm.vue?vue&type=style&index=1&id=aa591452&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa591452",
  null
  
)

export default component.exports